import React, { createContext, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

const createEmptyAuthData = () => ({
  token: null,
  userName: '',
  userId: '',
});

const decodeAuthToken = (token) => {
  const decoded = jwtDecode(token);

  return {
    userName: decoded?.user?.nome || '',
    userId: decoded?.user?.id || '',
  };
};

const getInitialAuthData = () => {
  const storedToken = localStorage.getItem('token');

  if (!storedToken) {
    return createEmptyAuthData();
  }

  try {
    return {
      token: storedToken,
      ...decodeAuthToken(storedToken),
    };
  } catch (error) {
    localStorage.removeItem('token');
    return createEmptyAuthData();
  }
};

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState(getInitialAuthData);
  const { token } = authData;

  useEffect(() => {
    if (token) {
      try {
        const decodedAuthData = decodeAuthToken(token);
        setAuthData((prevState) => {
          if (
            prevState.userName === decodedAuthData.userName &&
            prevState.userId === decodedAuthData.userId
          ) {
            return prevState;
          }

          return {
            ...prevState,
            ...decodedAuthData,
          };
        });
      } catch (error) {
        console.error('Erro ao decodificar o token:', error);
        setAuthData(createEmptyAuthData());
        localStorage.removeItem('token');
      }
    }
  }, [token]);

  const login = (newToken) => {
    try {
      const decodedAuthData = decodeAuthToken(newToken);
      localStorage.setItem('token', newToken);
      setAuthData({ token: newToken, ...decodedAuthData });
    } catch (error) {
      console.error('Erro ao salvar o token:', error);
      localStorage.removeItem('token');
      setAuthData(createEmptyAuthData());
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setAuthData(createEmptyAuthData());
  };

  const updateUserName = (newName) => {
    setAuthData((prevState) => ({
      ...prevState,
      userName: newName,
    }));
  };

  return (
    <AuthContext.Provider value={{ authData, login, logout, updateUserName }}>
      {children}
    </AuthContext.Provider>
  );
};
